// addUploadFeature.js

const convertFileToBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file.rawFile);

    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
  });

const addUploadFeature = (dataProvider) => {
  if (typeof dataProvider !== 'object' || !dataProvider) {
    console.error('dataProvider is not a valid object:', dataProvider);
    throw new Error('dataProvider must be a valid object');
  }

  return {
    ...dataProvider,
    create: (resource, params) => {
      const imgs = params.data ? params.data.newImg || params.data.imgs : null;

      if (resource === "campaigns") {
        if (imgs && !(imgs instanceof Array)) {
          // Handle single file upload for campaigns
          const myFile = imgs;
          if (!(myFile.rawFile instanceof File)) {
            return Promise.reject(new Error("Error: Not a valid file"));
          }

          return Promise.resolve(convertFileToBase64(myFile))
            .then((picture64) => ({
              src: picture64,
              title: myFile.title || "Campaign Image",
            }))
            .then((transformedMyFile) =>
              dataProvider.create(resource, {
                ...params,
                data: {
                  ...params.data,
                  myFile: transformedMyFile,
                },
              })
            )
            .catch((error) => {
              console.error("Error processing campaign image:", error);
              return Promise.reject(new Error("Failed to process campaign image"));
            });
        }
      } else if (resource === "products") {
        if (imgs && imgs.length >= 1 && typeof imgs[0] !== "string") {
          // Process multiple images for products
          const imagePromises = imgs.map((img) => {
            if (!(img.rawFile instanceof File)) {
              return Promise.reject(new Error("Error: Not a valid file"));
            }
            return convertFileToBase64(img);
          });
          return Promise.all(imagePromises)
            .then((base64Images) => ({
              src: base64Images,
              title: imgs.map(img => img.title || "Product Image"),
            }))
            .then((transformedFiles) =>
              dataProvider.create(resource, {
                ...params,
                data: {
                  ...params.data,
                  images: transformedFiles,
                },
              })
            )
            .catch((error) => {
              console.error("Error processing product images:", error);
              return Promise.reject(new Error("Failed to process product images"));
            });
        }
      }

      return dataProvider.create(resource, params);
    },
    update: (resource, params) => {
      const imgs = params.data ? params.data.newImg || params.data.imgs : null;

      if (resource === "campaigns") {
        if (imgs && !(imgs instanceof Array)) {
          // Handle single file upload for campaigns
          const myFile = imgs;
          if (!(myFile.rawFile instanceof File)) {
            return Promise.reject(new Error("Error: Not a valid file"));
          }

          return Promise.resolve(convertFileToBase64(myFile))
            .then((picture64) => ({
              src: picture64,
              title: myFile.title || "Campaign Image",
            }))
            .then((transformedMyFile) =>
              dataProvider.update(resource, {
                ...params,
                data: {
                  ...params.data,
                  myFile: transformedMyFile,
                },
              })
            )
            .catch((error) => {
              console.error("Error processing campaign image:", error);
              return Promise.reject(new Error("Failed to process campaign image"));
            });
        }
      } else if (resource === "products") {
        if (imgs && imgs.length >= 1 && typeof imgs[0] !== "string") {
          // Process multiple images for products
          const imagePromises = imgs.map((img) => {
            if (!(img.rawFile instanceof File)) {
              return Promise.reject(new Error("Error: Not a valid file"));
            }
            return convertFileToBase64(img);
          });

          return Promise.all(imagePromises)
            .then((base64Images) => ({
              src: base64Images,
              title: imgs.map(img => img.title || "Product Image"),
            }))
            .then((transformedFiles) =>
              dataProvider.update(resource, {
                ...params,
                data: {
                  ...params.data,
                  images: transformedFiles,
                },
              })
            )
            .catch((error) => {
              console.error("Error processing product images:", error);
              return Promise.reject(new Error("Failed to process product images"));
            });
        }
      }

      return dataProvider.update(resource, params);
    }
  };
};

export default addUploadFeature;
